import React, { useState } from 'react';
import { Loader2, Send } from 'lucide-react';

const WHATSAPP_NUMBER = '51921259616';
const CLASS_TITLE = 'De usar ChatGPT a trabajar con Inteligencia Artificial';

interface RegistrationFormProps {
  fechaLabel: string;
  horaLabel: string;
}

const INPUT_CLASS =
  'w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-white outline-none transition focus:border-mc-fuchsia/70 focus:ring-2 focus:ring-mc-fuchsia/25';

const RegistrationForm: React.FC<RegistrationFormProps> = ({ fechaLabel, horaLabel }) => {
  const [formData, setFormData] = useState({ nombre: '', correo: '', celular: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    const message = `Hola, quiero registrarme a la Masterclass gratuita 👋

*${CLASS_TITLE}*
📅 ${fechaLabel} · ${horaLabel} (Hora Perú)

Nombre y apellidos: *${formData.nombre}*
Correo electrónico: *${formData.correo}*
Celular / WhatsApp: *${formData.celular}*

¡Quedo atento(a) a la confirmación!`;

    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

    window.setTimeout(() => {
      window.open(whatsappUrl, '_blank');
      setIsLoading(false);
      setSent(true);
      setFormData({ nombre: '', correo: '', celular: '' });
    }, 500);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="nombre" className="mb-1.5 block text-sm font-medium text-white/80">
          Nombre y apellidos
        </label>
        <input
          id="nombre"
          name="nombre"
          type="text"
          required
          autoComplete="name"
          placeholder="Ingresa tu nombre y apellido"
          value={formData.nombre}
          onChange={handleChange}
          className={INPUT_CLASS}
        />
      </div>

      <div>
        <label htmlFor="correo" className="mb-1.5 block text-sm font-medium text-white/80">
          Correo electrónico
        </label>
        <input
          id="correo"
          name="correo"
          type="email"
          required
          autoComplete="email"
          placeholder="Ingresa tu correo electrónico"
          value={formData.correo}
          onChange={handleChange}
          className={INPUT_CLASS}
        />
      </div>

      <div>
        <label htmlFor="celular" className="mb-1.5 block text-sm font-medium text-white/80">
          Celular / WhatsApp
        </label>
        <input
          id="celular"
          name="celular"
          type="tel"
          required
          autoComplete="tel"
          placeholder="+51 999 999 999"
          value={formData.celular}
          onChange={handleChange}
          className={INPUT_CLASS}
        />
      </div>

      <button
        type="submit"
        disabled={isLoading}
        className="btn-mc-glow flex w-full items-center justify-center gap-2 px-6 py-4 disabled:cursor-not-allowed disabled:opacity-70 disabled:animate-none"
      >
        {isLoading ? (
          <>
            <Loader2 size={18} className="animate-spin" />
            <span>Enviando...</span>
          </>
        ) : (
          <>
            <Send size={18} />
            <span>Quiero registrarme gratis</span>
          </>
        )}
      </button>

      {sent && (
        <p className="animate-fade-in text-center text-sm font-medium text-emerald-300">
          ¡Registro recibido! Se abrió WhatsApp para confirmar tus datos — te contactaremos con el acceso a la
          clase.
        </p>
      )}
    </form>
  );
};

export default RegistrationForm;
